export default __webpack_public_path__ + "static/media/07__o_4.9080333b.jpg";